<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="openAdd"
      >添加</el-button
    >
    <el-dialog
      :visible="addDialogVisible"
      title="新增配置"
      width="40%"
      @close="closeDialog('changeForm')"
    >
      <el-form :model="changeForm" ref="changeForm" label-width="160px" :rules="rules">
        <el-form-item label="模块：" prop="module">
          <!-- <el-input v-model="changeForm.modlue" ></el-input> -->
          <el-select v-model="changeForm.module" placeholder="请选择">
            <el-option
              v-for="item in transferTypeData"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中文内容：">
          <el-input type="textarea" v-model="changeForm.contentZh"></el-input>
        </el-form-item>

        <el-form-item label="英文内容：">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="changeForm.contentEn"></el-input>
          </template>
        </el-form-item>

        <el-form-item label="开始时间：" prop="startTime">
          <template slot-scope="scope">
            <el-date-picker
              v-model="changeForm.startTime"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>
        </el-form-item>
        <el-form-item label="结束时间：" prop="endTime">
          <el-date-picker
            v-model="changeForm.endTime"
            type="datetime"
            placeholder="选择日期时间"
            align="right"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开关：">
          <!-- <el-input v-model="changeForm.isOpen"></el-input> -->
          <el-switch
            v-model="changeForm.isOpen"
           
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('changeForm')">取消</el-button>
        <el-button type="primary" @click="handleSave('changeForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "updatedialog",
  props: ["selected", "page", "size"],
  data() {
    return {
      changeForm: {
        module: "",
        contentZh: "",
        contentEn: "",
        startTime: "",
        endTime: "",
        isOpen: false,
      },
      statusOptions: [
        { value: 0, label: "是" },
        { value: 1, label: "不是" },
      ],
      rules: {
        module: [{ required: true, message: "请选择模块", trigger: 'change' }],
        isOpen: [{ required: true, message: "请选择开关状态", trigger: ['blur','change'] }],
        startTime: [{ required: true, message: "请选择开始时间", trigger: 'change'  }],
        endTime: [{ required: true, message: "请选择结束时间", trigger: 'change'  }],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  watch: {
    userinfoDetail(val, oldVal) {
      if (val !== oldVal) {
        this.changeForm = { ...val };
        this.changeForm.id = '';
      }
    },
  },
  computed: {
    ...mapState("maintenance", [
      "userinfoDetail",
      "addDialogVisible",
      "countryCodeList",
      "pagination",
      "queryType",
    ]),
    ...mapState("transferInner", ["transferTypeData"]),
    ...mapGetters("maintenance", ["userList"]),
  },
  methods: {
    ...mapMutations("maintenance", [
      "setAddDialogVisible",
      "setUserinfoDetail",
    ]),
    ...mapActions("transferInner", ["getTransferType"]),
    ...mapActions("maintenance", [
      "updatInfo",
      "list",
      "resetPassword",
      "updateSave",
      "getGasList",
    ]),
    closeDialog(formName) {
      this.setAddDialogVisible(false);
      this.$refs[formName].resetFields();
    },
    openAdd() {
      this.setAddDialogVisible(true);
    },
    handleSave(formName) {
      this.changeForm = {
        ...this.changeForm,
        startTime: this.changeForm.startTime.valueOf(),
        endTime: this.changeForm.endTime.valueOf(),
      };
      console.log(
        "thisssss",
        this.changeForm.startTime.valueOf(),
        this.changeForm
      );
        this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateSave({ ...this.changeForm }).then((res) => {
            if (res.code == 0) {
              this.$message.success("添加成功");
              this.setAddDialogVisible(false);
              this.$refs[formName].resetFields();
              this.$emit("refresh",this.pagination);
              // this.getGasList({page:this.page,size:this.size,coin:this.selected})
            } else {
              this.$message.success(res.msg || "添加失败，请重试");
            }
          });
        }
      });
      
    },
    resetLoginPassword(id) {
      this.resetPassword({ userId: id }).then(() => {
        this.$message.success("重置成功！");
      });
    },
  },
  created() {
    // this.getTransferType();
  },
};
</script>

<style lang="less" scoped>
// ::v-deep.el-select {
//   .el-input__inner {
//     width: 100px;
//   }
// }
</style>
